const RspCtrAcctHomePage = () => import('@/pages/proj/ctracct/rspCtrAcctHomePage')
const RspProjectHomePage = () => import('@/pages/proj/project/rspProjectHomePage')
const CompIncomeStatement = () => import('@/pages/proj/comprpt/compIncomeStatement')
const CompAssetDebt = () => import('@/pages/proj/comprpt/compAssetDebt')
const CompAcctReceive = () => import('@/pages/proj/comprpt/compAcctReceive')
const CompAcctPay = () => import('@/pages/proj/comprpt/compAcctPay')
const RspProjUserHomePage = () => import('@/pages/proj/projuser/rspProjUserHomePage')
const PdTypeLevelOne = () => import('@/pages/proj/conf/pdTypeLevelOne')
const PdName = () => import('@/pages/proj/conf/pdName')
const PdInquiry = () => import('@/pages/proj/conf/pdInquiry')
//
const ActionTrailHomePage = () => import('@/pages/audit/actionTrailHomePage')

export default [
  {
    name: 'RspCtrAcctHomePage',
    path: '/proj/ctracct',
    meta: {
      title: '核算主体管理'
    },
    component: RspCtrAcctHomePage,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'MTUJDI'
    }
  },
  {
    name: 'RspProjectHomePage',
    path: '/proj/project',
    meta: {
      title: '项目管理'
    },
    component: RspProjectHomePage,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'M35KUP'
    }
  },
  {
    name: 'CompIncomeStatement',
    path: '/proj/comprpt/compIncomeStatement',
    meta: {
      title: '损益表'
    },
    component: CompIncomeStatement,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'M9WTQC'
    }
  },
  {
    name: 'CompAssetDebt',
    path: '/proj/comprpt/compAssetDebt',
    meta: {
      title: '资产负债表'
    },
    component: CompAssetDebt,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'MZI7SJ'
    }
  },
  {
    name: 'CompAcctReceive',
    path: '/proj/comprpt/compAcctReceive',
    meta: {
      title: '应收统计表'
    },
    component: CompAcctReceive,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'MVEWVQ'
    }
  },
  {
    name: 'CompAcctPay',
    path: '/proj/comprpt/compAcctPay',
    meta: {
      title: '应付统计表'
    },
    component: CompAcctPay,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'M87SVY'
    }
  },
  {
    name: 'RspProjUserHomePage',
    path: '/proj/projuser',
    meta: {
      title: '项目财务用户权限'
    },
    component: RspProjUserHomePage,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'M678Q7'
    }
  },
  {
    name: 'PdTypeLevelOne',
    path: '/proj/conf/pdTypeLevelOne',
    meta: {
      title: '成控品名一级分类'
    },
    component: PdTypeLevelOne,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'MQ2LAR'
    }
  },
  {
    name: 'PdName',
    path: '/proj/conf/pdName',
    meta: {
      title: '成控品名'
    },
    component: PdName,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'MJP4WL'
    }
  },
  {
    name: 'PdInquiry',
    path: '/proj/conf/pdInquiry',
    meta: {
      title: '成控品名询价'
    },
    component: PdInquiry,
    props: {
      subsysKey: 'PROJ',
      moduleType: 'CONF',
      moduleCode: 'MJP4WL'
    }
  },
  {
    name: 'ActionTrailHomePage',
    path: '/api/audit/actiontrail',
    meta: {
      title: '历史事件'
    },
    component: ActionTrailHomePage,
    props: {
      subsysKey: 'SYS',
      moduleType: 'DATA',
      moduleCode: 'MU7IXX'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routerMap.js